const Roles = {
  1: "Forman",
  2: "General Forman",
  3: "Ops Manager",
  4: "Crew Member",
};

const EntryTypeOptions = [
  {
    label: "User",
    value: "user",
  },
  {
    label: "Equipment",
    value: "equipment",
  },
];

export { Roles, EntryTypeOptions };
